export default __webpack_public_path__ + "static/media/2198.e05e5ef2.png";